import { render, staticRenderFns } from "./changeUsername.vue?vue&type=template&id=16c47cdb&scoped=true"
import script from "./changeUsername.vue?vue&type=script&lang=js"
export * from "./changeUsername.vue?vue&type=script&lang=js"
import style0 from "./changeUsername.vue?vue&type=style&index=0&id=16c47cdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c47cdb",
  null
  
)

export default component.exports